import React, {useEffect, useState} from "react";
import PropTypes from "prop-types";

import ModalForm from "../../../../components/modalComponents/ModalForm";
import ConfirmarBeneficios from "./Pasos/ConfirmarBeneficios";
import SeleccionarBeneficios from "./Pasos/SeleccionarBeneficios";
import SolicitarBeneficios from "./Pasos/SolicitarBeneficios";
import useDidMountEffect from "../../../../hooks/useDidMountEffect/useDidMountEffect";
import {usePropsSelect} from "../../../../hooks/useProps/usePropsSelect";
import {useGetOptionsSelect} from '../../../../hooks/useGetOptionsSelect/useGetOptionsSelect';
import {initialAllOptionPromises, isNullOrUndefinded} from '../../../../helper/utils';
import {
    getCampanasBeneficioToSolicitarByEmpleadoAPI,
    getInitialDataToSolicitarBeneficioItemAPI,
    getTiposBeneficioItemWithTodosOptionAPI,
    getUbicacionesBeneficioItemWithTodosOptionAPI
} from '../../../../consumers/backendApisUrls';
import StepperBeneficios from "./components/StepperBeneficios";
import {useManageGetRequest} from "../../../../hooks/useManageGetRequest/useManageGetRequest";
import SeleccionarCampana from "./Pasos/SeleccionarCampana";

const KEYS = {
    idCampanaBeneficio: "IdCampanaBeneficio",
    cartaAutorizacionBeneficioFileViewModel: "CartaAutorizacionBeneficioFileViewModel",
    IdTipoBeneficioItem: "IdTipoBeneficioItem",
    IdUbicacionBeneficioItem: "IdUbicacionBeneficioItem",
    CuotasPago: "CuotasPago",
    NumeroWhatsApp: "NumeroWhatsApp",
};

const KEYS_DROPDOWN = ["IdCampanaBeneficio", "IdTipoBeneficioItem", "IdUbicacionBeneficioItem"];

const SECTION_NAME = "CrearSolicitudBeneficio";
const STEPS = {
    stepOne: {id: 1, name: "Campaña"},
    stepTwo: {id: 2, name: "Beneficios"},
    stepThree: {id: 3, name: "Confirma"},
    stepFour: {id: 4, name: "Solicita"},
};

const CrearSolicitudBeneficio = ({
                                toggleModal,
                                refreshPage,
                                idEmpleado: idEmpleadoProp,
                                idCampanaBeneficioPreseleccionada
        }) => {
        const [formValues, setFormValues] = useState({});
        const [allDropdowns, setAllDropdowns] = useState([]);
        const [disableSubmitButton, setDisableSubmitButton] = useState(false);
        const [getOption] = useGetOptionsSelect();
        const [selectProps] = usePropsSelect(
            allDropdowns,
            formValues,
            setFormValues,
            SECTION_NAME
        );
        const [currentStep, setCurrentStep] = useState(1);
        const [sendCurrentStep, setSendCurrentStep] = useState({
            step: 0,
            isSent: false,
        });

        const [modalData, setModalData] = useState({currentItems: [], currentTotal: 0});
        const [aceptoTerminosCondiciones, setAceptoTerminosCondiciones] = useState(false);
        const [isLoading, setIsLoading] = useState(false);

        const [executeManageGet] = useManageGetRequest();
        //const [isPreselected, setIsPreselected] = useState(false);
        // console.log('Prop idCampanaBeneficioPreseleccionada recibida:', idCampanaBeneficioPreseleccionada);
        // console.log('Todas las props recibidas en wizard:', { idEmpleado: idEmpleadoProp, idCampanaBeneficioPreseleccionada });
        // console.log('formValues después de montar:', formValues);

        useEffect(() => {
            getInitialData();
        }, []);

        useEffect(() => {
            if (modalData?.campanaBeneficioItemsToSolicitarResponse?.CuotasMax) {
                const cuotas = modalData.campanaBeneficioItemsToSolicitarResponse.CuotasMax;
                getDropdowns(cuotas);
            }

        }, [modalData?.campanaBeneficioItemsToSolicitarResponse?.CuotasMax]);

        useEffect(() => {
            if (idCampanaBeneficioPreseleccionada && !formValues[KEYS.idCampanaBeneficio]) {
                setFormValues(prev => ({
                    ...prev,
                    [KEYS.idCampanaBeneficio]: idCampanaBeneficioPreseleccionada
                }));
                //setIsPreselected(true);
            }
        }, [idCampanaBeneficioPreseleccionada]);

        // useDidMountEffect(() => {
        //     getInitialData();
        // }, [formValues[KEYS.idCampanaBeneficio]]);
        
        // useEffect(() => {
        //     if (formValues[KEYS.idCampanaBeneficio] && !isPreselected) {
        //         getInitialData();
        //     }else if (isPreselected) {
        //         setIsPreselected(false);
        //     }            
        // }, [formValues[KEYS.idCampanaBeneficio]]);

        useDidMountEffect(() => {
            if (sendCurrentStep.isSaved && !sendCurrentStep.isSent) {
                let newStep = currentStep;
                validateStep(++newStep);
                setSendCurrentStep({step: 0, isSent: false});
                setDisableSubmitButton(false);
            } else {
                setSendCurrentStep({step: currentStep, isSent: false});
                setDisableSubmitButton(false);
            }
        }, [sendCurrentStep.isSaved]);

        useEffect(() => {
            getDropdowns();
        }, [])

        async function getInitialData() {
            try {
                setIsLoading(true);
                const api = getInitialDataToSolicitarBeneficioItemAPI();
                await executeManageGet(api, (res) => successCallbackInitialData(res), false);
            } catch (error) {
                console.error(error)
            }finally{
                setIsLoading(false);
            }
        }

        const successCallbackInitialData = (res) => {
            setModalData({...modalData, initialDataResponse: res?.data});

            if (res?.data?.Campanas && res?.data?.Campanas?.length === 1) {
                //setFormValues({...formValues, [KEYS.idCampanaBeneficio]: res?.data?.Campanas[0].Value})
                setFormValues({...formValues})
            }
        }

        const getPayloadToSubmitItems = () => {
            let checkedCurrentItems = modalData?.currentItems?.filter(o => o.checked === true);
            let itemsForPayload = checkedCurrentItems.map(o => ({
                IdCampanaBeneficioItem: o?.IdCampanaBeneficioItem,
                Cantidad: o?.cantidad
            }))

            return {
                "CampanaBeneficioItems": itemsForPayload,
                "CuotasPago": formValues[KEYS.CuotasPago],
                "NumeroWhatsApp": formValues[KEYS.NumeroWhatsApp] ?? null
            }
        }

        const getPayloadToGetItems = () => {
            return {
                "IdCampanaBeneficio": formValues[KEYS.idCampanaBeneficio],
                "IdTipoBeneficioItem": formValues[KEYS.IdTipoBeneficioItem],
                "IdUbicacionBeneficioItem": formValues[KEYS.IdUbicacionBeneficioItem]
            }
        }

        const handleClick = (e, clickType) => {
            if (e) e.preventDefault();
            
            if (disableSubmitButton && clickType === "save") {
                return;
            }
            
            let newStep = currentStep;
            if (clickType === "save") {
                setDisableSubmitButton(true);
                setSendCurrentStep({step: currentStep, isSent: true});
            } else {
                if (currentStep === STEPS.stepFour.id) {
                    setFormValues({...formValues, [KEYS.cartaAutorizacionBeneficioFileViewModel]: undefined})
                }
                validateStep(--newStep);
            }
        };

        const validateStep = (newStep) => {
            if (newStep > 0 && newStep <= Object.keys(STEPS).length) {
                setCurrentStep(newStep);
            }
        };

        const getDropdowns = async (cuotas) => {
            const dropdownsPromises = () => [
                getOption(getCampanasBeneficioToSolicitarByEmpleadoAPI()),
                getOption(getTiposBeneficioItemWithTodosOptionAPI()),
                getOption(getUbicacionesBeneficioItemWithTodosOptionAPI()),
            ]
            await initialAllOptionPromises(dropdownsPromises, KEYS_DROPDOWN, (data) => handleDropdowns(data, cuotas));
        }

        const handleDropdowns = (data, cuotas) => {
            if(cuotas){
                const CuotasPago = {
                    key: "CuotasPago",
                    value: Array.from({ length: cuotas }, (_, i) => ({
                        value: i + 1,
                        label: `${i + 1}`,
                    })),
                };
                data.push(CuotasPago);
            }
            const updatedData = [...data];
            setAllDropdowns(updatedData);
        }

        const commonProps = () => {
            return {
                sendCurrentStep,
                setSendCurrentStep,
                KEYS,
                selectProps,
                SECTION_NAME,
                setFormValues,
                formValues,
                modalData,
                setModalData,
                getPayloadToSubmitItems,
                setDisableSubmitButton,
                toggleModal,
                refreshPage,
                getPayloadToGetItems,
                setAceptoTerminosCondiciones,
                aceptoTerminosCondiciones,
                isLoading,
                setIsLoading
            };
        };

        const stepComponents = {
            [STEPS.stepOne.id]: {
                component: <SeleccionarCampana {...commonProps()} />,
                name: STEPS.stepOne.name,
            },
            [STEPS.stepTwo.id]: {
                component: <SeleccionarBeneficios {...commonProps()} />,
                name: STEPS.stepTwo.name,
            },
            [STEPS.stepThree.id]: {
                component: <ConfirmarBeneficios {...commonProps()} />,
                name: STEPS.stepThree.name,
            },
            [STEPS.stepFour.id]: {
                component: <SolicitarBeneficios {...commonProps()} />,
                name: STEPS.stepFour.name,
            },
        };

        let stepsToRender = Object.values(stepComponents);


        return (
            <ModalForm
                titulo="Crear Solicitud"
                width="1100px"
                showModal={toggleModal}
                hasSaveButton={false}
            >
                <StepperBeneficios
                    steps={stepsToRender.map((step) => step.name)}
                    currentStepNumber={currentStep}
                    setCurrentStepNumber={setCurrentStep}
                    isObservated={false}
                />

                {React.cloneElement(stepsToRender[currentStep - 1].component, {
                    componentStep: currentStep,
                })}
                {
                    isLoading && (
                    <div className="text-center py-4">
                        <span className="spinner-border text-primary" role="status" />
                        <p>Cargando datos...</p>
                    </div>
                    )
                }
                <div
                    className="d-flex justify-content-around py-4"
                    style={{borderTop: "1px solid #dee2e6"}}
                >
                    {currentStep !== STEPS.stepOne.id && (
                        <button
                            onClick={(e) => handleClick(e, "back")}
                            className="btn btn-primary generic-button-ficha-modal"
                        >
                            Atrás
                        </button>
                    )}
                    {currentStep !== stepsToRender.length ? (
                        <button
                            type="button"
                            onClick={(e) => handleClick(e, "save")}
                            className="btn generic-button-buscador generic-button-hover-verde"
                            style={{backgroundColor: "#8DBA38"}}
                            disabled={!aceptoTerminosCondiciones || isNullOrUndefinded(formValues[KEYS.idCampanaBeneficio])}
                        >
                            {disableSubmitButton ? 'Procesando...' : 'Continuar'}
                        </button>
                    ) : (
                        <button
                            disabled={disableSubmitButton}
                            type="button"
                            onClick={(e) => handleClick(e, "save")}
                            className="btn generic-button-buscador generic-button-hover-verde"
                            style={{backgroundColor: "#8DBA38"}}
                        >
                            {disableSubmitButton ? 'Guardando...' : 'Guardar'}
                        </button>
                    )}
                </div>
            </ModalForm>
        );
    }
;

CrearSolicitudBeneficio.propTypes = {
    toggleModal: PropTypes.func.isRequired,
    refreshPage: PropTypes.func,
};

export default CrearSolicitudBeneficio;
